export default "__VITE_ASSET__ad20bbc9__"